module.exports = __webpack_public_path__ + "img/1.9ff37057.jpg";